export class CreateAccountPersonRequest
{
    id: number;
    targetId: number;
    integrationId: string;
    accountNumber: string;
    firstName: string;
    lastName: string;
    birthDate: Date;
    email: string;
    phone: string;
    taxId: string;
    initiatingUserId: number;
}

export class PaymentMethod
{
    id: number;
    methodId: number;
    integrationId: string;
    accountNumber: string;
    channelType: string;
    brandType: string;
    lastFour: string;
    nickName: string;
    clientId: number;
    riqUserId: number;
    isActive: boolean;
    isDefaultCard?: boolean;
    isAutoPayCard?: boolean;
    selected: boolean;
    vendorAccountId : number;
}

export class PropertyPaymentMethodHinge
{
    id: number;
    propertyId: number;
    paymentMethodId: number;
    isDefaultCard: boolean;
    isAutoPayCard: boolean;
    clientId: number;
    groupId: number;
}

export class PaymentGroupModel {
  public id: number;
  public groupName: string;
  public clientId: number;
  public selectedLocations: number[] = [];
}

export class RIQPaymentRequest
{
    methodId: number;
    accountPersonId: number;
    /**The amount in cents needed to make a payment. */
    amount: number;
    cvv: string;
    invoiceHistoryId: number;
    screeningDraftId: number;
    receiptEmails : string;
}